import { useSelector } from "react-redux";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { getIndexesGosrComments } from "slices/indexesGosr/indexesGosrSelectors";

import { IndexesGosrCommentsList } from "./IndexesGosrCommentsList";

export const IndexesGosrCommentsModal = ({ open, onClose }) => {
	const comments = useSelector(getIndexesGosrComments);

	return (
		<Dialog
			fullWidth
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: {
					maxWidth: comments.length > 0 ? "600px" : "300px",
				},
			}}
		>
			<DialogTitle>Примечание</DialogTitle>
			<DialogContent>
				<IndexesGosrCommentsList comments={comments} />
			</DialogContent>
			<DialogActions>
				<Button size="small" onClick={onClose}>
					Закрыть
				</Button>
			</DialogActions>
		</Dialog>
	);
};
